import { configureStore } from "@reduxjs/toolkit";
import cookiePopupReducer from "../components/CookiePopup/CookiePopupSlice";

export default configureStore({
  reducer: {
    cookiePopup: cookiePopupReducer,
  },
});
